import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '@/modules/core/app/constants/ModelType';
import { TypeformThreshold } from '@/modules/typeform/models/TypeformThreshold';
import { DiagnosticToolFormType } from '../constants/DiagnosticToolFormType';

export class TypeformForm extends BaseEntityModel {
  id?: string;
  type?: DiagnosticToolFormType;
  title?: string;
  language?: string;
  isActive?: boolean;
  jurisdictionId?: number;
  lastUpdatedAt?: string;

  typeformThresholds: Relationship<TypeformThreshold[] | null>;

  constructor(model: Partial<TypeformForm> = {}) {
    super(model);

    this.id = model.id;
    this.type = model.type as DiagnosticToolFormType;
    this.title = model.title;
    this.language = model.language;
    this.isActive = model.isActive;
    this.lastUpdatedAt = model.lastUpdatedAt;
    this.jurisdictionId = model.jurisdictionId;

    // @ts-ignore
    this.typeformThresholds = TypeformThreshold.mapModelsOrNull(model.typeformThresholds);
  }

  getModelName(): ModelType {
    return ModelType.TYPEFORM_FORM;
  }
}
